import { Box, Link, Card, Container, Typography } from '@mui/material';

// material
import { styled } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';

import { ForgotPasswordForm } from '../components/authentication/forogtPassword';
import { MHidden } from '../components/@material-extend';
// components
import Page from '../components/Page';
// layouts
import AuthLayout from '../layouts/AuthLayout';
import { useTranslation } from '../common/LocalizationProvider';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 600,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  margin: theme.spacing(2, 0, 2, 2),
  backgroundColor: theme.palette.primary.main
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function ForgotPassword() {
  const t = useTranslation();
  return (
    <RootStyle title={t('FP_Title')}>
      <AuthLayout>
        {t('FP_AuthLayout')}&nbsp;
        <Link underline="none" variant="subtitle2" component={RouterLink} to="/login">
          {t('FP_AuthLayout_Login')}
        </Link>
      </AuthLayout>

      <MHidden width="mdDown">
        <SectionStyle>
          <img src="/static/logo.svg" alt="CTO logo" width={160} />
          <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }} color="white" textAlign="center">
            {t('FP_Quote')}
          </Typography>
          <Typography variant="subtitle1" color="white">
            {t('FP_Quote_Author')}
          </Typography>
        </SectionStyle>
      </MHidden>

      <Container>
        <ContentStyle>
          <Box sx={{ mb: 5 }}>
            <Typography variant="h4" gutterBottom>
              {t('FP_Subtitle_1')}
            </Typography>
            <Typography sx={{ color: 'text.secondary' }}>{t('FP_Subtitle_2')} </Typography>
          </Box>

          <ForgotPasswordForm />

          <MHidden width="smUp">
            <Typography variant="subtitle2" sx={{ mt: 3, textAlign: 'center' }}>
              {t('FP_AuthLayout')}&nbsp;
              <Link to="/login" component={RouterLink}>
                {t('FP_AuthLayout_Login')}
              </Link>
            </Typography>
          </MHidden>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
